
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`/pricings/${this.$route.query.id}`).then(res => {
        this.form = { ...this.form, ...res.data }
      })
    },
    save() {
      this.$http
        .put(`/pricings/${this.$route.query.id}`, {
          ...this.form,
          chargeItemId: this.chargeItem.id
        })
        .then(() => {
          this.$router.go(-1)
        })
        .catch(err => this.$catch(err))
    },
    remove() {
      this.$http.delete(`/pricings/${this.$route.query.id}`).then(() => {
        this.$router.go(-1)
      })
    }
  }
}
</script>
